import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import CardGrid from '@stories/Components/CardGrid/CardGrid';
import CardGridStyles, { cardWidth } from '@stories/Components/CardGrid/CardGrid.styles';
import UspCardStyles from '@stories/Components/Cards/UspCard/UspCard.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import TitleAndIntroductionStyles from '@stories/Components/Misc/TitleAndIntroduction/TitleAndIntroduction.styles';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  overflow: hidden;

  --borderColour: ${rgba(brand.grey.light, 0.5)};
  --sectionSpacing: ${fluid(32, 80)};

  &[data-bg-colour='navy'] {
    --borderColour: ${rgba(brand.grey.background, 0.2)};
  }

  &[data-bg-colour='beige'] {
    --borderColour: ${rgba(brand.grey.dark, 0.2)};
  }

  &[data-bg-colour='light-blue'] {
    --borderColour: ${rgba(brand.blue.default, 0.2)};
  }

  &[data-bg-colour='light-green'] {
    --borderColour: ${rgba(brand.green.default, 0.2)};
  }

  ${SectionWrapperStyles.Inner} {
    display: flex;
    flex-direction: column;

    ${TitleAndIntroductionStyles.Container} {
      margin-bottom: ${fluid(32, 58)};
    }

    > ${ButtonStyles.Container} {
      margin: ${fluid(32, 80)} auto 0;
    }
  }

  ${UspCardStyles.Container} {
    ${cardWidth};

    padding-bottom: 16px;
    border-bottom: 1px solid var(--borderColour);

    &:last-of-type {
      padding-right: 0;
      border-bottom: none;
    }

    @media ${from(Device.TabletLarge)} {
      border: none;
      padding-bottom: 0;
    }
  }

  &[data-is-carousel='true'] {
    ${CardGridStyles.Item} {
      &:last-of-type {
        ${UspCardStyles.Container} {
          padding-right: 0;
          border-right: none;
        }
      }
    }

    ${UspCardStyles.Container} {
      padding-bottom: 0;
      padding-right: var(--gap);
      border-bottom: 0;
      border-right: 1px solid var(--borderColour);

      @media ${from(Device.TabletLarge)} {
        border: none;
        padding-right: 0;
      }
    }
  }
`;
const Grid = styled(CardGrid) `
  --grow: 0;
  --itemPeek: 0px;

  [data-is-carousel='true'] & {
    --itemPeek: 40px;
    --gap: ${fluid(16, 32)};
  }

  row-gap: ${fluid(40, 144)};

  @media ${from(Device.TabletSmall)} {
    --rowItems: 2 !important; // Important required to prevent CLS specificity issue
    --itemPeek: 0px;

    [data-is-carousel='true'] & {
      --itemPeek: 80px;
    }
  }

  @media ${from(Device.TabletLarge)} {
    --rowItems: 3 !important;
  }

  @media ${from(Device.Desktop)} {
    --rowItems: 4 !important;
  }

  ${Container}[data-columns='5'] & {
    @media ${from(Device.DesktopLarge)} {
      --rowItems: 5 !important;
    }
  }
`;
const UspsStyles = {
    Container,
    Grid,
};
export default UspsStyles;
